export default __webpack_public_path__ + "static/media/project_bullground_3.22d2ec69.png";